var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPenCircle(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_25731",
    "data-name": "Group 25731",
    transform: "translate(-1233 -1119)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1563",
    "data-name": "Ellipse 1563",
    cx: 9.5,
    cy: 9.5,
    r: 9.5,
    transform: "translate(1233 1119)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "edit",
    transform: "translate(1238.035 1124.035)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_24394",
    "data-name": "Group 24394"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_24393",
    "data-name": "Group 24393"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7333",
    "data-name": "Path 7333",
    d: "M0,73.168v1.788H1.788l5.275-5.275L5.275,67.893Z",
    transform: "translate(0 -66.376)",
    fill: "#172b37"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7334",
    "data-name": "Path 7334",
    d: "M261.326,1.253,260.213.139a.478.478,0,0,0-.675,0l-.872.872L260.454,2.8l.872-.872A.478.478,0,0,0,261.326,1.253Z",
    transform: "translate(-252.886)",
    fill: "#172b37"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPenCircle);
export default __webpack_public_path__ + "static/media/pen-circle.a1fc0a0df64eb7dd8839f0cf403b69af.svg";
export { ForwardRef as ReactComponent };